import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';

import { ShareService } from '@core/services/share.service';

@Component({
  selector: 'app-property-share-emails',
  templateUrl: './share-emails.component.html',
  styleUrls: ['./share-emails.component.scss'],
})
export class PropertyShareEmailsComponent {
  @Input({ required: true }) propertyId: string = '';
  @Output() handleClose = new EventEmitter<void>();

  constructor(
    private shareService: ShareService,
    private cdr: ChangeDetectorRef
  ) {}

  protected emailValue = '';
  protected emailInvalid = false;
  protected emailTouched = false;
  protected emails: string[] = [];

  protected sending = false;
  protected sendResp:
    | { type: 'success' | 'error'; message: string }
    | undefined;

  addEmail() {
    this.sendResp = undefined;
    if (this.isValidEmail(this.emailValue)) {
      this.emails.push(this.emailValue);
      this.emailValue = '';
      this.emailInvalid = false;
      this.emailTouched = false;
    } else {
      this.emailInvalid = true;
      this.emailTouched = true;
    }
  }

  removeEmail(index: number) {
    this.emails.splice(index, 1);
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  responseError() {
    this.sendResp = {
      type: 'error',
      message: 'Failed to share property. Please try again later.',
    };

    this.sending = false;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.sendResp = undefined;
      this.cdr.detectChanges();
    }, 7000);
  }

  onEmailBlur() {
    this.emailTouched = true;
  }

  async handleSend() {
    this.sending = true;
    this.sendResp = undefined;

    this.shareService
      .shareProperty({
        id: this.propertyId,
        input: {
          source: 'EMAIL',
          emails: this.emails,
        },
      })
      .subscribe({
        next: (res) => {
          if (
            res.data?.shareProperty.errors &&
            res.data?.shareProperty.errors.length
          ) {
            this.responseError();
            return;
          }
          this.sendResp = {
            type: 'success',
            message: 'Property shared successfully!',
          };
          this.emails = [];
          this.emailValue = '';
          this.emailInvalid = false;
          this.emailTouched = false;

          this.sending = false;
          this.cdr.detectChanges();
          setTimeout(() => {
            this.sendResp = undefined;
            this.cdr.detectChanges();
          }, 7000);
        },
        error: (err) => this.responseError(),
      });
  }
}
